var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "ShortUrlList",
      "extra-items": _vm.isReadOnly ? [{
        text: _vm.shortUrl.title
      }] : _vm.isEditing ? [{
        text: _vm.shortUrl.title,
        to: 'ShortUrlView',
        params: _vm.$route.params.short_url_id
      }, '編輯短網址'] : ['新增短網址']
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "查看短網址" : _vm.isEditing ? "編輯短網址" : "新增短網址") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-md": "2",
      "label-size": "",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.title,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl, "title", $$v);
      },
      expression: "shortUrl.title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-size": "lg",
      "label": "目標網址"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "label-cols": "2",
      "stacked": ""
    },
    model: {
      value: _vm.shortUrl.url_type,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl, "url_type", $$v);
      },
      expression: "shortUrl.url_type"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "oa"
    }
  }, [_vm._v(" LINE 官方帳號")]), _c('b-form-radio', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v(" 自訂網址 "), _c('b-form-input', {
    staticClass: "m-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.url,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl, "url", $$v);
      },
      expression: "shortUrl.url"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.shortUrl.line_uid_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl, "line_uid_enabled", $$v);
      },
      expression: "shortUrl.line_uid_enabled"
    }
  }, [_vm._v(" 帶出會員 LINE ID ， LINE UID 網址參數 "), _c('b-form-input', {
    staticClass: "m-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.line_uid,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl, "line_uid", $$v);
      },
      expression: "shortUrl.line_uid"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-size": "lg",
      "label": "UTM"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-md": "2",
      "label-size": "sm",
      "label": "utm_source"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 utm-input-width",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.utm.source,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl.utm, "source", $$v);
      },
      expression: "shortUrl.utm.source"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-md": "2",
      "label-size": "sm",
      "label": "utm_medium"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 utm-input-width",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.utm.medium,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl.utm, "medium", $$v);
      },
      expression: "shortUrl.utm.medium"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-md": "2",
      "label-size": "sm",
      "label": "utm_campaign"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 utm-input-width",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.utm.campaign,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl.utm, "campaign", $$v);
      },
      expression: "shortUrl.utm.campaign"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-md": "2",
      "label-size": "sm",
      "label": "utm_term"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 utm-input-width",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.utm.term,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl.utm, "term", $$v);
      },
      expression: "shortUrl.utm.term"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-md": "2",
      "label-size": "sm",
      "label": "utm_content"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 utm-input-width",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.utm.content,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl.utm, "content", $$v);
      },
      expression: "shortUrl.utm.content"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-size": "lg",
      "label": "設定"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": _vm.handlePermissionsChange
    },
    model: {
      value: _vm.permissionRegistered,
      callback: function callback($$v) {
        _vm.permissionRegistered = $$v;
      },
      expression: "permissionRegistered"
    }
  }, [_vm._v(" 需註冊 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-size": "lg",
      "label": "觸發事件"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.shortUrl.allow_duplicated,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl, "allow_duplicated", $$v);
      },
      expression: "shortUrl.allow_duplicated"
    }
  }, [_vm._v(" 會員重複點擊時，允許重複觸發事件 ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "貼標"
    }
  }, [_c('div', {
    staticClass: "border rounded p-1"
  }, [_vm._l(_vm.shortUrl.tags, function (tag, index) {
    return _c('b-badge', {
      key: tag.id,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(" " + _vm._s(tag.name) + " "), _c('button', {
      staticClass: "btn btn-xs p-0",
      on: {
        "click": function click($event) {
          return _vm.handleClickRemoveTag(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove text-white"
    })])]);
  }), _c('b-input', {
    staticClass: "border-0",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "placeholder": "輸入標籤"
    },
    on: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnterInputTag.apply(null, arguments);
      }, _vm.handleKeyUpInputTag],
      "blur": _vm.handleEnterInputTag
    },
    model: {
      value: _vm.inputTag,
      callback: function callback($$v) {
        _vm.inputTag = $$v;
      },
      expression: "inputTag"
    }
  })], 2), false ? [_c('div', {
    staticClass: "h6 mt-3"
  }, [_vm._v("現有標籤")]), _vm._l(_vm.shortUrl.tags, function (i) {
    return _c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }],
      key: i,
      staticClass: "m-1 text-dark",
      attrs: {
        "variant": "secondary",
        "size": "xs"
      }
    }, [_vm._v(" " + _vm._s(i) + " ")]);
  })] : _vm._e()], 2), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放優惠卷"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "options": _vm.redeemCodes,
      "disabled": _vm.isReadOnly,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.shortUrl.redeem_code_bundle_id,
      callback: function callback($$v) {
        _vm.$set(_vm.shortUrl, "redeem_code_bundle_id", $$v);
      },
      expression: "shortUrl.redeem_code_bundle_id"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger",
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存 ")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }